import React from 'react';
import styled from '@emotion/styled';

interface Props {
  from: string;
  to: string;
}

const Component: React.FCX<Props> = ({ className }) => <div className={className}></div>;

const StyledComponent = styled(Component)`
  height: 20vh;
  width: 100%;
  background: linear-gradient(to left bottom, ${({ from, to }) => `${from} 49.5%, ${to} 50%`}),
    linear-gradient(to right bottom, ${({ from, to }) => `${from} 49.5%, ${to} 50%`});
  background-position: bottom left, bottom right;
  background-size: 50% 100%;
  background-repeat: no-repeat;

`;

export default StyledComponent;
